<template>
  <div class="bh-page">
    <header class="bh-page-hero">
      <div v-reveal class="bh-container">
        <h1 class="bh-page-hero__title">Contact us</h1>
        <p class="bh-page-hero__lead">
          Questions about events, sponsorship, or membership? We would like to
          hear from you.
        </p>
      </div>
    </header>

    <section class="bh-section">
      <div v-reveal="{ variant: 'scale' }" class="bh-container contact-panel">
        <h2 class="bh-section__title">Email</h2>
        <p>
          Reach the foundation directly at
          <a :href="'mailto:' + email">{{ email }}</a>.
        </p>
        <div class="contact-actions">
          <a class="bh-btn bh-btn--secondary" :href="'mailto:' + email">
            Send an email
          </a>
          <router-link class="bh-btn bh-btn--primary" to="/donate">
            Donate
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ContactUsPage",
  data() {
    return {
      email: "blackhillsmountainlionhunters@gmail.com",
    };
  },
};
</script>

<style scoped>
.contact-panel {
  max-width: 40rem;
  background: var(--bh-surface);
  border: 1px solid var(--bh-border);
  border-radius: var(--bh-radius);
  box-shadow: var(--bh-shadow);
  padding: 2rem;
}

.contact-panel p {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--bh-ink);
  margin: 0 0 1.5rem;
}

.contact-panel a {
  color: var(--bh-forest);
  font-weight: 600;
}

.contact-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}
</style>
